// //client/src/pages/Payments/Payments.jsx
// import React, { useState, useMemo } from "react";
// import { PageHeader } from "@/components/common/PageHeader";
// import { SectionCard } from "@/components/common/SectionCard";
// import { StatusBadge } from "@/components/common/StatusBadge";
// import { Button } from "@/components/ui/button";
// import { Checkbox } from "@/components/ui/checkbox";
// import { Label } from "@/components/ui/label";
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
// import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
// import { SERIES, MONTHLY_CALCS, monthLabel } from "@/mock/data";
// import { inr } from "@/lib/format";
// import { paymentService } from "@/services";
// import { toast } from "sonner";
// import { CheckCheck, Download } from "lucide-react";

// export default function Payments() {
//   const [series, setSeries] = useState(SERIES[0].id);
//   const rows = useMemo(() =>
//     MONTHLY_CALCS
//       .filter((c) => c.series === series && (c.status === "Approved" || c.status === "Payment Generated" || c.status === "Closed"))
//       .sort((a, b) => b.month.localeCompare(a.month)),
//     [series]
//   );
//   const [selected, setSelected] = useState([]);
//   const [confirmOpen, setConfirmOpen] = useState(false);

//   const toggle = (id) => setSelected((s) => s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
//   const selectableRows = rows.filter((r) => (r.paymentStatus || "Confirmation Pending") !== "All Confirmed");
//   const toggleAll = () => setSelected(selected.length === selectableRows.length ? [] : selectableRows.map((r) => r.id));

//   const selectedTotal = rows.filter((r) => selected.includes(r.id)).reduce((a, r) => a + r.net, 0);
//   const selectedTds = rows.filter((r) => selected.includes(r.id)).reduce((a, r) => a + r.tds, 0);

//   const download = async (r) => {
//     await paymentService.downloadExcel("interest", r.id);
//     toast.success(`${monthLabel(r.month)} · Excel download requested for review.`);
//   };
//   const confirmAll = async () => {
//     await paymentService.markConfirmed(selected);
//     toast.success(`${selected.length} month(s) marked as All Confirmed.`);
//     setSelected([]); setConfirmOpen(false);
//   };

//   return (
//     <div>
//       <PageHeader
//         title="Payments"
//         subtitle="Track monthly interest payments per series. Download the Excel to review before confirming — this tracker does not process bank transactions."
//       />
//       <SectionCard title="Select NCD Series" description="Interest payment records are scoped to a series.">
//         <div className="max-w-md">
//           <Label>NCD Series</Label>
//           <Select value={series} onValueChange={(v) => { setSeries(v); setSelected([]); }}>
//             <SelectTrigger data-testid="pay-series"><SelectValue /></SelectTrigger>
//             <SelectContent>{SERIES.map((s) => (<SelectItem key={s.id} value={s.id}>{s.id} · {s.name}</SelectItem>))}</SelectContent>
//           </Select>
//         </div>
//       </SectionCard>

//       <div className="mt-6">
//         <SectionCard
//           title="Monthly interest payment records"
//           description={`${rows.length} month(s). Download the Excel to review before confirming — selection can represent a quarter (Jul + Aug + Sep = Q2).`}
//           action={
//             <Button data-testid="btn-mark-confirmed" disabled={selected.length === 0} className="bg-primary hover:bg-primary/90" onClick={() => setConfirmOpen(true)}>
//               <CheckCheck className="mr-2 h-4 w-4" />Mark {selected.length || ""} as Confirmed
//             </Button>
//           }
//         >
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead className="bg-secondary/50 text-left text-xs uppercase tracking-wider text-muted-foreground">
//                 <tr>
//                   <th className="w-10 px-4 py-3"><Checkbox data-testid="chk-all" checked={selectableRows.length > 0 && selected.length === selectableRows.length} onCheckedChange={toggleAll} /></th>
//                   <th className="px-4 py-3">Period</th>
//                   <th className="px-4 py-3">Series</th>
//                   <th className="px-4 py-3 text-right">Gross Interest</th>
//                   <th className="px-4 py-3 text-right">TDS</th>
//                   <th className="px-4 py-3 text-right">Net Payable</th>
//                   <th className="px-4 py-3">Status</th>
//                   <th className="px-4 py-3 text-right"></th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-border">
//                 {rows.map((r) => {
//                   const status = r.paymentStatus === "All Confirmed" ? "All Confirmed" : "Confirmation Pending";
//                   return (
//                     <tr key={r.id} className="row-hover" data-testid={`pay-row-${r.id}`}>
//                       <td className="px-4 py-3"><Checkbox data-testid={`chk-${r.id}`} checked={selected.includes(r.id)} onCheckedChange={() => toggle(r.id)} disabled={status === "All Confirmed"} /></td>
//                       <td className="px-4 py-3 font-medium">{monthLabel(r.month)}</td>
//                       <td className="px-4 py-3 num text-xs">{r.series}</td>
//                       <td className="px-4 py-3 num text-right">{inr(r.gross)}</td>
//                       <td className="px-4 py-3 num text-right text-muted-foreground">{inr(r.tds)}</td>
//                       <td className="px-4 py-3 num text-right font-medium">{inr(r.net)}</td>
//                       <td className="px-4 py-3"><StatusBadge>{status}</StatusBadge></td>
//                       <td className="px-4 py-3 text-right">
//                         <Button data-testid={`dl-${r.id}`} size="sm" variant="outline" className="h-7" onClick={() => download(r)}>
//                           <Download className="mr-1.5 h-3.5 w-3.5" />Download Excel
//                         </Button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//             {rows.length === 0 && <div className="p-8 text-center text-sm text-muted-foreground">No payment records available for this series.</div>}
//           </div>
//         </SectionCard>
//       </div>

//       <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
//         <DialogContent>
//           <DialogHeader>
//             <DialogTitle>Confirm {selected.length} month{selected.length !== 1 ? "s" : ""}?</DialogTitle>
//             <DialogDescription>Marking a month as <span className="font-medium">All Confirmed</span> is an operational tracking action. Please review the downloaded Excel first.</DialogDescription>
//           </DialogHeader>
//           <div className="rounded-md border border-border p-3 text-sm">
//             <div className="flex justify-between"><span className="text-muted-foreground">Net Payable</span><span className="num font-medium">{inr(selectedTotal)}</span></div>
//             <div className="mt-1 flex justify-between"><span className="text-muted-foreground">TDS obligation</span><span className="num font-medium">{inr(selectedTds)}</span></div>
//           </div>
//           <DialogFooter>
//             <Button variant="outline" onClick={() => setConfirmOpen(false)}>Cancel</Button>
//             <Button data-testid="btn-confirm-all" onClick={confirmAll} className="bg-primary hover:bg-primary/90">Confirm as paid</Button>
//           </DialogFooter>
//         </DialogContent>
//       </Dialog>
//     </div>
//   );
// }



// // client/src/pages/Payments/Payments.jsx

// import React, { useState, useMemo } from "react";
// import { PageHeader } from "@/components/common/PageHeader";
// import { SectionCard } from "@/components/common/SectionCard";
// import { StatusBadge } from "@/components/common/StatusBadge";
// import { Button } from "@/components/ui/button";
// import { Checkbox } from "@/components/ui/checkbox";
// import { Label } from "@/components/ui/label";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";

// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
// } from "@/components/ui/dialog";

// import { SERIES, MONTHLY_CALCS, monthLabel } from "@/mock/data";
// import { inr } from "@/lib/format";
// import { paymentService } from "@/services";
// import { toast } from "sonner";

// import {
//   CheckCheck,
//   Download,
//   Upload,
//   FileSpreadsheet,
//   CheckCircle2,
//   XCircle,
//   AlertCircle,
//   Loader2,
// } from "lucide-react";

// export default function Payments() {
//   const [series, setSeries] = useState(SERIES[0].id);

//   const rows = useMemo(
//     () =>
//       MONTHLY_CALCS.filter(
//         (c) =>
//           c.series === series &&
//           (c.status === "Approved" ||
//             c.status === "Payment Generated" ||
//             c.status === "Closed")
//       ).sort((a, b) => b.month.localeCompare(a.month)),
//     [series]
//   );

//   const [selected, setSelected] = useState([]);
//   const [confirmOpen, setConfirmOpen] = useState(false);

//   // Payment Upload States
//   const [uploadOpen, setUploadOpen] = useState(false);
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [processing, setProcessing] = useState(false);
//   const [processed, setProcessed] = useState(false);

//   const toggle = (id) =>
//     setSelected((s) =>
//       s.includes(id) ? s.filter((x) => x !== id) : [...s, id]
//     );

//   const selectableRows = rows.filter(
//     (r) => (r.paymentStatus || "Confirmation Pending") !== "All Confirmed"
//   );

//   const toggleAll = () =>
//     setSelected(
//       selected.length === selectableRows.length
//         ? []
//         : selectableRows.map((r) => r.id)
//     );

//   const selectedTotal = rows
//     .filter((r) => selected.includes(r.id))
//     .reduce((a, r) => a + r.net, 0);

//   const selectedTds = rows
//     .filter((r) => selected.includes(r.id))
//     .reduce((a, r) => a + r.tds, 0);

//   const download = async (r) => {
//     await paymentService.downloadExcel("interest", r.id);

//     toast.success(
//       `${monthLabel(r.month)} · Excel download requested for review.`
//     );
//   };

//   const confirmAll = async () => {
//     await paymentService.markConfirmed(selected);

//     toast.success(
//       `${selected.length} month(s) marked as All Confirmed.`
//     );

//     setSelected([]);
//     setConfirmOpen(false);
//   };

//   // ---------------------------------------------------------
//   // MOCK PAYMENT FILE PROCESSING
//   // ---------------------------------------------------------

//   const handlePaymentFile = (event) => {
//     const file = event.target.files?.[0];

//     if (!file) return;

//     setUploadedFile(file);
//     setProcessed(false);
//   };

//   const processPaymentFile = () => {
//     if (!uploadedFile) {
//       toast.error("Please upload the bank payment confirmation file.");
//       return;
//     }

//     setProcessing(true);
//     setProcessed(false);

//     // Mock processing delay for client demonstration
//     setTimeout(() => {
//       setProcessing(false);
//       setProcessed(true);

//       toast.success("Payment file processed successfully.");
//     }, 1800);
//   };

//   const closeUploadDialog = () => {
//     setUploadOpen(false);
//     setUploadedFile(null);
//     setProcessing(false);
//     setProcessed(false);
//   };

//   // ---------------------------------------------------------
//   // MOCK INVESTOR RESULTS
//   //
//   // These represent the data that would eventually come
//   // from the uploaded bank confirmation Excel.
//   // ---------------------------------------------------------

//   const paymentResults = [
//     {
//       folio: "NCD10001",
//       investor: "Rahul Sharma",
//       expectedAmount: 408,
//       paidAmount: 408,
//       status: "Paid Successfully",
//       error: null,
//     },
//     {
//       folio: "NCD10002",
//       investor: "Priya Mehta",
//       expectedAmount: 8070,
//       paidAmount: 8070,
//       status: "Paid Successfully",
//       error: null,
//     },
//     {
//       folio: "NCD10003",
//       investor: "Amit Verma",
//       expectedAmount: 408,
//       paidAmount: 0,
//       status: "Failed",
//       error: "IFSC incorrect",
//     },
//     {
//       folio: "NCD10004",
//       investor: "Neha Kapoor",
//       expectedAmount: 1200,
//       paidAmount: 1200,
//       status: "Paid Successfully",
//       error: null,
//     },
//   ];

//   const successCount = paymentResults.filter(
//     (r) => r.status === "Paid Successfully"
//   ).length;

//   const failedCount = paymentResults.filter(
//     (r) => r.status === "Failed"
//   ).length;

//   const totalProcessed = paymentResults.length;

//   return (
//     <div>
//       <PageHeader
//         title="Payments"
//         subtitle="Track monthly interest payments per series. Download the Excel to review before confirming — this tracker does not process bank transactions."
//       />

//       <SectionCard
//         title="Select NCD Series"
//         description="Interest payment records are scoped to a series."
//       >
//         <div className="max-w-md">
//           <Label>NCD Series</Label>

//           <Select
//             value={series}
//             onValueChange={(v) => {
//               setSeries(v);
//               setSelected([]);
//             }}
//           >
//             <SelectTrigger data-testid="pay-series">
//               <SelectValue />
//             </SelectTrigger>

//             <SelectContent>
//               {SERIES.map((s) => (
//                 <SelectItem key={s.id} value={s.id}>
//                   {s.id} · {s.name}
//                 </SelectItem>
//               ))}
//             </SelectContent>
//           </Select>
//         </div>
//       </SectionCard>

//       <div className="mt-6">
//         <SectionCard
//           title="Monthly interest payment records"
//           description={`${rows.length} month(s). Download the Excel to review before confirming — selection can represent a quarter (Jul + Aug + Sep = Q2).`}
//           action={
//             <Button
//               data-testid="btn-mark-confirmed"
//               disabled={selected.length === 0}
//               className="bg-primary hover:bg-primary/90"
//               onClick={() => setConfirmOpen(true)}
//             >
//               <CheckCheck className="mr-2 h-4 w-4" />

//               Mark {selected.length || ""} as Confirmed
//             </Button>
//           }
//         >
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead className="bg-secondary/50 text-left text-xs uppercase tracking-wider text-muted-foreground">
//                 <tr>
//                   <th className="w-10 px-4 py-3">
//                     <Checkbox
//                       data-testid="chk-all"
//                       checked={
//                         selectableRows.length > 0 &&
//                         selected.length === selectableRows.length
//                       }
//                       onCheckedChange={toggleAll}
//                     />
//                   </th>

//                   <th className="px-4 py-3">Period</th>

//                   <th className="px-4 py-3">Series</th>

//                   <th className="px-4 py-3 text-right">
//                     Gross Interest
//                   </th>

//                   <th className="px-4 py-3 text-right">TDS</th>

//                   <th className="px-4 py-3 text-right">
//                     Net Payable
//                   </th>

//                   <th className="px-4 py-3">Status</th>

//                   <th className="px-4 py-3 text-right">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>

//               <tbody className="divide-y divide-border">
//                 {rows.map((r) => {
//                   const status =
//                     r.paymentStatus === "All Confirmed"
//                       ? "All Confirmed"
//                       : "Confirmation Pending";

//                   return (
//                     <tr
//                       key={r.id}
//                       className="row-hover"
//                       data-testid={`pay-row-${r.id}`}
//                     >
//                       <td className="px-4 py-3">
//                         <Checkbox
//                           data-testid={`chk-${r.id}`}
//                           checked={selected.includes(r.id)}
//                           onCheckedChange={() => toggle(r.id)}
//                           disabled={status === "All Confirmed"}
//                         />
//                       </td>

//                       <td className="px-4 py-3 font-medium">
//                         {monthLabel(r.month)}
//                       </td>

//                       <td className="px-4 py-3 num text-xs">
//                         {r.series}
//                       </td>

//                       <td className="px-4 py-3 num text-right">
//                         {inr(r.gross)}
//                       </td>

//                       <td className="px-4 py-3 num text-right text-muted-foreground">
//                         {inr(r.tds)}
//                       </td>

//                       <td className="px-4 py-3 num text-right font-medium">
//                         {inr(r.net)}
//                       </td>

//                       <td className="px-4 py-3">
//                         <StatusBadge>{status}</StatusBadge>
//                       </td>

//                       <td className="px-4 py-3">
//                         <div className="flex justify-end gap-2">
//                           {/* DOWNLOAD EXCEL */}

//                           <Button
//                             data-testid={`dl-${r.id}`}
//                             size="sm"
//                             variant="outline"
//                             className="h-8"
//                             onClick={() => download(r)}
//                           >
//                             <Download className="mr-1.5 h-3.5 w-3.5" />

//                             Download Excel
//                           </Button>

//                           {/* UPLOAD PAYMENT FILE */}

//                           <Button
//                             data-testid={`upload-payment-${r.id}`}
//                             size="sm"
//                             className="h-8"
//                             onClick={() => {
//                               setUploadOpen(true);
//                               setUploadedFile(null);
//                               setProcessed(false);
//                             }}
//                           >
//                             <Upload className="mr-1.5 h-3.5 w-3.5" />

//                             Upload Payment File
//                           </Button>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>

//             {rows.length === 0 && (
//               <div className="p-8 text-center text-sm text-muted-foreground">
//                 No payment records available for this series.
//               </div>
//             )}
//           </div>
//         </SectionCard>
//       </div>

//       {/* =====================================================
//           PAYMENT FILE UPLOAD / PROCESSING DIALOG
//       ===================================================== */}

//       <Dialog open={uploadOpen} onOpenChange={setUploadOpen}>
//         <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
//           <DialogHeader>
//             <DialogTitle className="flex items-center gap-2">
//               <FileSpreadsheet className="h-5 w-5" />

//               Upload Bank Payment Confirmation
//             </DialogTitle>

//             <DialogDescription>
//               Upload the bank confirmation Excel file for the selected
//               NCD series. The system will identify investors, compare
//               payment amounts and generate a payment exception report.
//             </DialogDescription>
//           </DialogHeader>

//           {/* SELECTED SERIES */}

//           <div className="rounded-lg border bg-secondary/30 p-4">
//             <div className="grid grid-cols-3 gap-4 text-sm">
//               <div>
//                 <p className="text-xs text-muted-foreground">
//                   NCD Series
//                 </p>

//                 <p className="mt-1 font-medium">
//                   {series}
//                 </p>
//               </div>

//               <div>
//                 <p className="text-xs text-muted-foreground">
//                   Payment Period
//                 </p>

//                 <p className="mt-1 font-medium">
//                   Monthly Interest Payment
//                 </p>
//               </div>

//               <div>
//                 <p className="text-xs text-muted-foreground">
//                   Expected Records
//                 </p>

//                 <p className="mt-1 font-medium">
//                   {paymentResults.length} investors
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* FILE UPLOAD */}

//           {!processed && (
//             <div className="mt-4">
//               <label
//                 htmlFor="payment-file"
//                 className="flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-border p-10 transition hover:bg-secondary/30"
//               >
//                 <Upload className="mb-3 h-8 w-8 text-muted-foreground" />

//                 <p className="font-medium">
//                   Upload Bank Confirmation Excel
//                 </p>

//                 <p className="mt-1 text-xs text-muted-foreground">
//                   XLS / XLSX files supported
//                 </p>

//                 {uploadedFile && (
//                   <div className="mt-4 rounded-md bg-secondary px-4 py-2 text-sm">
//                     <FileSpreadsheet className="mr-2 inline h-4 w-4" />

//                     {uploadedFile.name}
//                   </div>
//                 )}

//                 <input
//                   id="payment-file"
//                   type="file"
//                   accept=".xls,.xlsx"
//                   className="hidden"
//                   onChange={handlePaymentFile}
//                 />
//               </label>

//               <div className="mt-4 flex justify-end">
//                 <Button
//                   disabled={!uploadedFile || processing}
//                   onClick={processPaymentFile}
//                 >
//                   {processing ? (
//                     <>
//                       <Loader2 className="mr-2 h-4 w-4 animate-spin" />

//                       Processing Bank File...
//                     </>
//                   ) : (
//                     <>
//                       Process Payment File
//                     </>
//                   )}
//                 </Button>
//               </div>
//             </div>
//           )}

//           {/* MOCK PROCESSING RESULT */}

//           {processed && (
//             <div className="space-y-5">
//               {/* SUMMARY */}

//               <div className="grid grid-cols-3 gap-4">
//                 <div className="rounded-lg border p-4">
//                   <p className="text-xs text-muted-foreground">
//                     Total Investors
//                   </p>

//                   <p className="mt-1 text-2xl font-semibold">
//                     {totalProcessed}
//                   </p>
//                 </div>

//                 <div className="rounded-lg border border-green-200 bg-green-50 p-4">
//                   <p className="text-xs text-green-700">
//                     Payment Successful
//                   </p>

//                   <p className="mt-1 text-2xl font-semibold text-green-700">
//                     {successCount}
//                   </p>
//                 </div>

//                 <div className="rounded-lg border border-red-200 bg-red-50 p-4">
//                   <p className="text-xs text-red-700">
//                     Payment Exceptions
//                   </p>

//                   <p className="mt-1 text-2xl font-semibold text-red-700">
//                     {failedCount}
//                   </p>
//                 </div>
//               </div>

//               {/* RESULT TABLE */}

//               <div>
//                 <div className="mb-3 flex items-center justify-between">
//                   <div>
//                     <h3 className="font-medium">
//                       Payment Verification Report
//                     </h3>

//                     <p className="text-xs text-muted-foreground">
//                       Investor-wise payment status identified from
//                       the uploaded bank confirmation file.
//                     </p>
//                   </div>

//                   <StatusBadge>
//                     File Processed
//                   </StatusBadge>
//                 </div>

//                 <div className="overflow-hidden rounded-lg border">
//                   <table className="w-full text-sm">
//                     <thead className="bg-secondary/50">
//                       <tr>
//                         <th className="px-4 py-3 text-left">
//                           Folio Number
//                         </th>

//                         <th className="px-4 py-3 text-left">
//                           Investor
//                         </th>

//                         <th className="px-4 py-3 text-right">
//                           Expected Amount
//                         </th>

//                         <th className="px-4 py-3 text-right">
//                           Paid Amount
//                         </th>

//                         <th className="px-4 py-3 text-left">
//                           Status
//                         </th>

//                         <th className="px-4 py-3 text-left">
//                           Exception
//                         </th>
//                       </tr>
//                     </thead>

//                     <tbody className="divide-y">
//                       {paymentResults.map((result) => {
//                         const success =
//                           result.status === "Paid Successfully";

//                         return (
//                           <tr key={result.folio}>
//                             <td className="px-4 py-3 font-medium">
//                               {result.folio}
//                             </td>

//                             <td className="px-4 py-3">
//                               {result.investor}
//                             </td>

//                             <td className="px-4 py-3 text-right">
//                               {inr(result.expectedAmount)}
//                             </td>

//                             <td className="px-4 py-3 text-right font-medium">
//                               {inr(result.paidAmount)}
//                             </td>

//                             <td className="px-4 py-3">
//                               {success ? (
//                                 <span className="inline-flex items-center gap-1.5 text-green-600">
//                                   <CheckCircle2 className="h-4 w-4" />

//                                   Paid Successfully
//                                 </span>
//                               ) : (
//                                 <span className="inline-flex items-center gap-1.5 text-red-600">
//                                   <XCircle className="h-4 w-4" />

//                                   Failed
//                                 </span>
//                               )}
//                             </td>

//                             <td className="px-4 py-3">
//                               {result.error ? (
//                                 <span className="inline-flex items-center gap-1.5 text-red-600">
//                                   <AlertCircle className="h-4 w-4" />

//                                   {result.error}
//                                 </span>
//                               ) : (
//                                 <span className="text-muted-foreground">
//                                   —
//                                 </span>
//                               )}
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               {/* DEMO EMAIL MESSAGE */}

//               <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
//                 <div className="flex gap-3">
//                   <AlertCircle className="mt-0.5 h-5 w-5 text-blue-600" />

//                   <div>
//                     <p className="font-medium text-blue-900">
//                       Investor Notification Preview
//                     </p>

//                     <p className="mt-1 text-sm text-blue-800">
//                       After confirmation, the system will send the
//                       appropriate payment notification to each
//                       investor. Successful investors will receive
//                       their payment amount, while failed transactions
//                       will receive the applicable exception reason.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           <DialogFooter>
//             <Button
//               variant="outline"
//               onClick={closeUploadDialog}
//             >
//               {processed ? "Close" : "Cancel"}
//             </Button>

//             {processed && (
//               <Button
//                 onClick={() => {
//                   toast.success(
//                     "Payment results confirmed. Investor notifications queued for demonstration."
//                   );

//                   closeUploadDialog();
//                 }}
//               >
//                 <CheckCheck className="mr-2 h-4 w-4" />

//                 Confirm Payment Results
//               </Button>
//             )}
//           </DialogFooter>
//         </DialogContent>
//       </Dialog>

//       {/* =====================================================
//           EXISTING CONFIRM DIALOG
//       ===================================================== */}

//       <Dialog
//         open={confirmOpen}
//         onOpenChange={setConfirmOpen}
//       >
//         <DialogContent>
//           <DialogHeader>
//             <DialogTitle>
//               Confirm {selected.length} month
//               {selected.length !== 1 ? "s" : ""}?
//             </DialogTitle>

//             <DialogDescription>
//               Marking a month as{" "}
//               <span className="font-medium">
//                 All Confirmed
//               </span>{" "}
//               is an operational tracking action. Please review the
//               downloaded Excel first.
//             </DialogDescription>
//           </DialogHeader>

//           <div className="rounded-md border border-border p-3 text-sm">
//             <div className="flex justify-between">
//               <span className="text-muted-foreground">
//                 Net Payable
//               </span>

//               <span className="num font-medium">
//                 {inr(selectedTotal)}
//               </span>
//             </div>

//             <div className="mt-1 flex justify-between">
//               <span className="text-muted-foreground">
//                 TDS obligation
//               </span>

//               <span className="num font-medium">
//                 {inr(selectedTds)}
//               </span>
//             </div>
//           </div>

//           <DialogFooter>
//             <Button
//               variant="outline"
//               onClick={() => setConfirmOpen(false)}
//             >
//               Cancel
//             </Button>

//             <Button
//               data-testid="btn-confirm-all"
//               onClick={confirmAll}
//               className="bg-primary hover:bg-primary/90"
//             >
//               Confirm as paid
//             </Button>
//           </DialogFooter>
//         </DialogContent>
//       </Dialog>
//     </div>
//   );
// }


// client/src/pages/Payments/Payments.jsx

import React, { useState, useMemo, useRef } from "react";

import { PageHeader } from "@/components/common/PageHeader";
import { SectionCard } from "@/components/common/SectionCard";
import { StatusBadge } from "@/components/common/StatusBadge";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import {
  SERIES,
  MONTHLY_CALCS,
  monthLabel,
} from "@/mock/data";

import { inr } from "@/lib/format";
import { paymentService } from "@/services";
import { toast } from "sonner";

import {
  CheckCheck,
  Download,
  Upload,
  FileSpreadsheet,
  CheckCircle2,
  XCircle,
  Loader2,
  FileCheck2,
  Database,
  Search,
  AlertCircle,
  ArrowLeft,
  Mail,
} from "lucide-react";


/* =========================================================
   MOCK BANK PAYMENT DATA
   ---------------------------------------------------------
   This is ONLY for demonstration.

   Later this data will come from the uploaded bank Excel.
========================================================= */

const MOCK_BANK_RESULTS = [
  {
    id: "INV-001",
    investorName: "Abhishek Singh",
    email: "abrijput0186@gmail.com",
    folio: "F-000112",
    expectedAmount: 408,
    paidAmount: 408,
    status: "Paid Successfully",
    reason: null,
  },
  {
    id: "INV-002",
    investorName: "Abhishek Singh",
    email: "rounakksingh0100@gmail.com",
    folio: "F-000113",
    expectedAmount: 8070,
    paidAmount: 8070,
    status: "Paid Successfully",
    reason: null,
  },
  {
    id: "INV-003",
    investorName: "Rajesh Kumar",
    email: "rajesh.kumar@example.com",
    folio: "F-000114",
    expectedAmount: 4080,
    paidAmount: 0,
    status: "Payment Failed",
    reason: "IFS / beneficiary details incorrect",
  },
  {
    id: "INV-004",
    investorName: "Priya Sharma",
    email: "priya.sharma@example.com",
    folio: "F-000115",
    expectedAmount: 12500,
    paidAmount: 12500,
    status: "Paid Successfully",
    reason: null,
  },
];


/* =========================================================
   PROCESSING STEPS
========================================================= */

const PROCESSING_STEPS = [
  {
    id: 1,
    title: "Reading Bank Payment File",
    description: "Reading payment records and transaction details",
    icon: FileSpreadsheet,
  },
  {
    id: 2,
    title: "Finding Investor Records",
    description: "Matching folio numbers with investor records",
    icon: Search,
  },
  {
    id: 3,
    title: "Matching Payment Amounts",
    description: "Comparing expected amount with bank payment amount",
    icon: Database,
  },
  {
    id: 4,
    title: "Validating Payment Status",
    description: "Identifying successful and failed transactions",
    icon: FileCheck2,
  },
];


export default function Payments() {

  /* =======================================================
     EXISTING PAYMENT PAGE STATE
  ======================================================= */

  const [series, setSeries] = useState(SERIES[0].id);

  const rows = useMemo(
    () =>
      MONTHLY_CALCS
        .filter(
          (c) =>
            c.series === series &&
            (
              c.status === "Approved" ||
              c.status === "Payment Generated" ||
              c.status === "Closed"
            )
        )
        .sort((a, b) => b.month.localeCompare(a.month)),
    [series]
  );

  const [selected, setSelected] = useState([]);

  const [confirmOpen, setConfirmOpen] = useState(false);


  /* =======================================================
     PAYMENT FILE WORKFLOW STATE
  ======================================================= */

  const [uploadOpen, setUploadOpen] = useState(false);

  const [selectedPaymentRow, setSelectedPaymentRow] = useState(null);

  const [paymentFile, setPaymentFile] = useState(null);

  const [processing, setProcessing] = useState(false);

  const [processingStep, setProcessingStep] = useState(0);

  const [processingComplete, setProcessingComplete] = useState(false);

  const [bankResults, setBankResults] = useState([]);

  const fileInputRef = useRef(null);


  /* =======================================================
     EXISTING FUNCTIONS
  ======================================================= */

  const toggle = (id) =>
    setSelected((s) =>
      s.includes(id)
        ? s.filter((x) => x !== id)
        : [...s, id]
    );


  const selectableRows = rows.filter(
    (r) =>
      (r.paymentStatus || "Confirmation Pending") !==
      "All Confirmed"
  );


  const toggleAll = () =>
    setSelected(
      selected.length === selectableRows.length
        ? []
        : selectableRows.map((r) => r.id)
    );


  const selectedTotal = rows
    .filter((r) => selected.includes(r.id))
    .reduce((a, r) => a + r.net, 0);


  const selectedTds = rows
    .filter((r) => selected.includes(r.id))
    .reduce((a, r) => a + r.tds, 0);


  const download = async (r) => {
    await paymentService.downloadExcel("interest", r.id);

    toast.success(
      `${monthLabel(r.month)} · Excel download requested for review.`
    );
  };


  const confirmAll = async () => {

    await paymentService.markConfirmed(selected);

    toast.success(
      `${selected.length} month(s) marked as All Confirmed.`
    );

    setSelected([]);

    setConfirmOpen(false);
  };


  /* =======================================================
     OPEN PAYMENT UPLOAD
  ======================================================= */

  const openPaymentUpload = (row) => {

    setSelectedPaymentRow(row);

    setPaymentFile(null);

    setProcessing(false);

    setProcessingStep(0);

    setProcessingComplete(false);

    setBankResults([]);

    setUploadOpen(true);
  };


  /* =======================================================
     FILE SELECTION
  ======================================================= */

  const handleFileChange = (event) => {

    const file = event.target.files?.[0];

    if (!file) return;

    const validExcel =
      file.name.toLowerCase().endsWith(".xlsx") ||
      file.name.toLowerCase().endsWith(".xls") ||
      file.name.toLowerCase().endsWith(".csv");

    if (!validExcel) {

      toast.error(
        "Please upload an Excel or CSV bank payment file."
      );

      return;
    }

    setPaymentFile(file);
  };


  /* =======================================================
     START MOCK PROCESSING
  ======================================================= */

  const startProcessing = () => {

    if (!paymentFile) {

      toast.error("Please select the bank payment file first.");

      return;
    }

    setUploadOpen(false);

    setProcessing(true);

    setProcessingStep(0);

    setProcessingComplete(false);

    setBankResults([]);

    /*
      Mock processing sequence.

      Step 1
      Step 2
      Step 3
      Step 4
      Final result
    */

    let currentStep = 0;

    const interval = setInterval(() => {

      currentStep += 1;

      setProcessingStep(currentStep);

      if (currentStep >= PROCESSING_STEPS.length) {

        clearInterval(interval);

        setTimeout(() => {

          setBankResults(MOCK_BANK_RESULTS);

          setProcessingComplete(true);

          setProcessing(false);

        }, 800);
      }

    }, 1200);
  };


  /* =======================================================
     BACK TO PAYMENTS
  ======================================================= */

  const backToPayments = () => {

    setProcessing(false);

    setProcessingComplete(false);

    setProcessingStep(0);

    setBankResults([]);

    setPaymentFile(null);

    setSelectedPaymentRow(null);
  };


  /* =======================================================
     CONFIRM + SEND EMAIL MOCK
  ======================================================= */

  const confirmAndSendNotifications = () => {

    const successful = bankResults.filter(
      (r) => r.status === "Paid Successfully"
    ).length;

    const failed = bankResults.filter(
      (r) => r.status === "Payment Failed"
    ).length;

    toast.success(
      `${successful} payment notifications ready. ${failed} failed records flagged.`
    );

    /*
      IMPORTANT:

      This is currently a frontend-only demonstration.

      Later this function can call:

      paymentService.confirmBankPayment(...)
      paymentService.sendInvestorNotifications(...)

      and the backend can update MongoDB + send emails.
    */
  };


  /* =======================================================
     PROCESSING SCREEN
  ======================================================= */

  if (processing) {

    const progress = Math.min(
      (processingStep / PROCESSING_STEPS.length) * 100,
      100
    );

    return (
      <div>

        <PageHeader
          title="Processing Bank Payment File"
          subtitle="Please keep this window open while the payment records are being verified."
        />

        <div className="grid gap-6 lg:grid-cols-2">

          {/* LEFT SIDE */}

          <SectionCard
            title="Bank Payment Verification"
            description={
              paymentFile
                ? paymentFile.name
                : "Processing payment file"
            }
          >

            <div className="space-y-6">

              {/* PROCESSING HEADER */}

              <div className="flex items-center gap-4 rounded-lg border bg-secondary/30 p-5">

                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">

                  <Loader2 className="h-6 w-6 animate-spin text-primary" />

                </div>

                <div>

                  <div className="font-semibold">
                    Payment Verification in Progress
                  </div>

                  <div className="text-sm text-muted-foreground">
                    Matching bank transactions with investor records
                  </div>

                </div>

              </div>


              {/* PROGRESS */}

              <div>

                <div className="mb-2 flex justify-between text-sm">

                  <span className="font-medium">
                    Overall Progress
                  </span>

                  <span className="font-semibold text-primary">
                    {Math.round(progress)}%
                  </span>

                </div>

                <div className="h-2 overflow-hidden rounded-full bg-secondary">

                  <div
                    className="h-full rounded-full bg-primary transition-all duration-700"
                    style={{
                      width: `${progress}%`,
                    }}
                  />

                </div>

              </div>


              {/* STEPS */}

              <div className="space-y-5">

                {PROCESSING_STEPS.map((step) => {

                  const StepIcon = step.icon;

                  const completed =
                    processingStep >= step.id;

                  const active =
                    processingStep + 1 === step.id;

                  return (
                    <div
                      key={step.id}
                      className="flex items-start gap-4"
                    >

                      <div
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${
                          completed
                            ? "bg-primary text-primary-foreground"
                            : active
                              ? "bg-primary/10 text-primary"
                              : "bg-secondary text-muted-foreground"
                        }`}
                      >

                        {completed ? (
                          <CheckCircle2 className="h-5 w-5" />
                        ) : active ? (
                          <Loader2 className="h-5 w-5 animate-spin" />
                        ) : (
                          <StepIcon className="h-4 w-4" />
                        )}

                      </div>


                      <div>

                        <div
                          className={`font-medium ${
                            !completed && !active
                              ? "text-muted-foreground"
                              : ""
                          }`}
                        >
                          {step.title}
                        </div>

                        <div className="text-sm text-muted-foreground">
                          {step.description}
                        </div>

                      </div>

                    </div>
                  );
                })}

              </div>

            </div>

          </SectionCard>


          {/* RIGHT SIDE */}

          <SectionCard
            title="File in Queue"
            description="Bank confirmation file being processed"
          >

            <div className="space-y-5">

              <div className="flex items-center gap-4 rounded-lg border p-4">

                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-green-50">

                  <FileSpreadsheet className="h-6 w-6 text-green-600" />

                </div>

                <div className="min-w-0 flex-1">

                  <div className="truncate font-medium">
                    {paymentFile?.name || "Bank Payment File.xlsx"}
                  </div>

                  <div className="text-sm text-muted-foreground">
                    {selectedPaymentRow
                      ? `${monthLabel(selectedPaymentRow.month)} · ${selectedPaymentRow.series}`
                      : "Payment verification"}
                  </div>

                </div>

                <StatusBadge>
                  PROCESSING
                </StatusBadge>

              </div>


              <div className="rounded-lg border border-blue-200 bg-blue-50 p-4 text-sm text-blue-800">

                <div className="flex gap-3">

                  <AlertCircle className="mt-0.5 h-5 w-5 shrink-0" />

                  <div>

                    <div className="font-medium">
                      Secure payment reconciliation
                    </div>

                    <div className="mt-1 text-blue-700">
                      The bank file is being matched against
                      investor folio numbers and expected payment
                      amounts.

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </SectionCard>

        </div>

      </div>
    );
  }


  /* =======================================================
     FINAL RESULT SCREEN
  ======================================================= */

  if (processingComplete) {

    const successful = bankResults.filter(
      (r) => r.status === "Paid Successfully"
    );

    const failed = bankResults.filter(
      (r) => r.status === "Payment Failed"
    );

    const totalExpected = bankResults.reduce(
      (sum, r) => sum + r.expectedAmount,
      0
    );

    const totalPaid = bankResults.reduce(
      (sum, r) => sum + r.paidAmount,
      0
    );


    return (
      <div>

        <PageHeader
          title="Bank Payment Verification Complete"
          subtitle="Review the payment reconciliation results before confirming investor notifications."
        />


        {/* SUMMARY */}

        <div className="grid gap-4 md:grid-cols-4 mb-6">

          <div className="rounded-lg border bg-card p-5">

            <div className="text-sm text-muted-foreground">
              Investors Found
            </div>

            <div className="mt-2 text-2xl font-semibold">
              {bankResults.length}
            </div>

          </div>


          <div className="rounded-lg border border-green-200 bg-green-50 p-5">

            <div className="text-sm text-green-700">
              Paid Successfully
            </div>

            <div className="mt-2 text-2xl font-semibold text-green-700">
              {successful.length}
            </div>

          </div>


          <div className="rounded-lg border border-red-200 bg-red-50 p-5">

            <div className="text-sm text-red-700">
              Payment Failed
            </div>

            <div className="mt-2 text-2xl font-semibold text-red-700">
              {failed.length}
            </div>

          </div>


          <div className="rounded-lg border bg-card p-5">

            <div className="text-sm text-muted-foreground">
              Total Paid
            </div>

            <div className="mt-2 text-2xl font-semibold">
              {inr(totalPaid)}
            </div>

          </div>

        </div>


        {/* FILE INFORMATION */}

        <SectionCard
          title="Bank File Reconciliation"
          description={
            paymentFile
              ? `${paymentFile.name} · ${selectedPaymentRow ? monthLabel(selectedPaymentRow.month) : ""}`
              : "Payment reconciliation"
          }
        >

          <div className="mb-5 grid gap-4 md:grid-cols-3">

            <div className="rounded-md border p-4">

              <div className="text-sm text-muted-foreground">
                Expected Payment
              </div>

              <div className="mt-1 font-semibold">
                {inr(totalExpected)}
              </div>

            </div>


            <div className="rounded-md border p-4">

              <div className="text-sm text-muted-foreground">
                Bank Paid Amount
              </div>

              <div className="mt-1 font-semibold">
                {inr(totalPaid)}
              </div>

            </div>


            <div className="rounded-md border p-4">

              <div className="text-sm text-muted-foreground">
                Difference
              </div>

              <div className="mt-1 font-semibold">
                {inr(totalExpected - totalPaid)}
              </div>

            </div>

          </div>


          {/* RESULTS TABLE */}

          <div className="overflow-x-auto">

            <table className="w-full text-sm">

              <thead className="bg-secondary/50 text-left text-xs uppercase tracking-wider text-muted-foreground">

                <tr>

                  <th className="px-4 py-3">
                    Investor
                  </th>

                  <th className="px-4 py-3">
                    Folio Number
                  </th>

                  <th className="px-4 py-3">
                    Email
                  </th>

                  <th className="px-4 py-3 text-right">
                    Expected Amount
                  </th>

                  <th className="px-4 py-3 text-right">
                    Paid Amount
                  </th>

                  <th className="px-4 py-3">
                    Status
                  </th>

                  <th className="px-4 py-3">
                    Result
                  </th>

                </tr>

              </thead>


              <tbody className="divide-y divide-border">

                {bankResults.map((r) => {

                  const success =
                    r.status === "Paid Successfully";

                  return (
                    <tr
                      key={r.id}
                      className="row-hover"
                    >

                      <td className="px-4 py-4">

                        <div className="font-medium">
                          {r.investorName}
                        </div>

                      </td>


                      <td className="px-4 py-4 font-mono text-xs">
                        {r.folio}
                      </td>


                      <td className="px-4 py-4 text-muted-foreground">
                        {r.email}
                      </td>


                      <td className="px-4 py-4 text-right font-medium">
                        {inr(r.expectedAmount)}
                      </td>


                      <td className="px-4 py-4 text-right font-medium">
                        {inr(r.paidAmount)}
                      </td>


                      <td className="px-4 py-4">

                        {success ? (
                          <span className="inline-flex items-center gap-1.5 rounded-full border border-green-200 bg-green-50 px-2.5 py-1 text-xs font-medium text-green-700">

                            <CheckCircle2 className="h-3.5 w-3.5" />

                            Paid Successfully

                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-1.5 rounded-full border border-red-200 bg-red-50 px-2.5 py-1 text-xs font-medium text-red-700">

                            <XCircle className="h-3.5 w-3.5" />

                            Payment Failed

                          </span>
                        )}

                      </td>


                      <td className="px-4 py-4">

                        {success ? (

                          <div className="flex items-center gap-2 text-sm text-green-700">

                            <CheckCircle2 className="h-4 w-4" />

                            Amount matched

                          </div>

                        ) : (

                          <div>

                            <div className="flex items-center gap-2 text-sm font-medium text-red-700">

                              <AlertCircle className="h-4 w-4" />

                              {r.reason}

                            </div>

                            <div className="mt-1 text-xs text-muted-foreground">
                              Folio: {r.folio}
                            </div>

                          </div>

                        )}

                      </td>

                    </tr>
                  );
                })}

              </tbody>

            </table>

          </div>


          {/* EMAIL EXPLANATION */}

          <div className="mt-6 rounded-lg border border-blue-200 bg-blue-50 p-5">

            <div className="flex gap-3">

              <Mail className="mt-0.5 h-5 w-5 text-blue-600" />

              <div>

                <div className="font-medium text-blue-900">
                  Investor notification preview
                </div>

                <div className="mt-1 text-sm text-blue-800">

                  After confirmation, successful investors will
                  receive their payment confirmation email with
                  the paid amount. Failed transactions will receive
                  the applicable failure reason.

                </div>

              </div>

            </div>

          </div>


          {/* ACTIONS */}

          <div className="mt-6 flex flex-wrap justify-end gap-3">

            <Button
              variant="outline"
              onClick={backToPayments}
            >
              <ArrowLeft className="mr-2 h-4 w-4" />

              Back to Payments

            </Button>


            <Button
              className="bg-primary hover:bg-primary/90"
              onClick={confirmAndSendNotifications}
            >
              <Mail className="mr-2 h-4 w-4" />

              Confirm & Send Notifications

            </Button>

          </div>

        </SectionCard>

      </div>
    );
  }


  /* =======================================================
     NORMAL PAYMENTS SCREEN
  ======================================================= */

  return (
    <div>

      <PageHeader
        title="Payments"
        subtitle="Track monthly interest payments per series. Download the Excel to review before confirming — this tracker does not process bank transactions."
      />


      <SectionCard
        title="Select NCD Series"
        description="Interest payment records are scoped to a series."
      >

        <div className="max-w-md">

          <Label>
            NCD Series
          </Label>

          <Select
            value={series}
            onValueChange={(v) => {
              setSeries(v);
              setSelected([]);
            }}
          >

            <SelectTrigger data-testid="pay-series">

              <SelectValue />

            </SelectTrigger>


            <SelectContent>

              {SERIES.map((s) => (

                <SelectItem
                  key={s.id}
                  value={s.id}
                >
                  {s.id} · {s.name}
                </SelectItem>

              ))}

            </SelectContent>

          </Select>

        </div>

      </SectionCard>


      <div className="mt-6">

        <SectionCard
          title="Monthly interest payment records"
          description={`${rows.length} month(s). Download the Excel to review before confirming — selection can represent a quarter (Jul + Aug + Sep = Q2).`}
          action={
            <Button
              data-testid="btn-mark-confirmed"
              disabled={selected.length === 0}
              className="bg-primary hover:bg-primary/90"
              onClick={() => setConfirmOpen(true)}
            >

              <CheckCheck className="mr-2 h-4 w-4" />

              Mark {selected.length || ""} as Confirmed

            </Button>
          }
        >

          <div className="overflow-x-auto">

            <table className="w-full text-sm">

              <thead className="bg-secondary/50 text-left text-xs uppercase tracking-wider text-muted-foreground">

                <tr>

                  <th className="w-10 px-4 py-3">

                    <Checkbox
                      data-testid="chk-all"
                      checked={
                        selectableRows.length > 0 &&
                        selected.length === selectableRows.length
                      }
                      onCheckedChange={toggleAll}
                    />

                  </th>

                  <th className="px-4 py-3">
                    Period
                  </th>

                  <th className="px-4 py-3">
                    Series
                  </th>

                  <th className="px-4 py-3 text-right">
                    Gross Interest
                  </th>

                  <th className="px-4 py-3 text-right">
                    TDS
                  </th>

                  <th className="px-4 py-3 text-right">
                    Net Payable
                  </th>

                  <th className="px-4 py-3">
                    Status
                  </th>

                  <th className="px-4 py-3 text-right">
                    Actions
                  </th>

                </tr>

              </thead>


              <tbody className="divide-y divide-border">

                {rows.map((r) => {

                  const status =
                    r.paymentStatus === "All Confirmed"
                      ? "All Confirmed"
                      : "Confirmation Pending";


                  return (

                    <tr
                      key={r.id}
                      className="row-hover"
                      data-testid={`pay-row-${r.id}`}
                    >

                      <td className="px-4 py-3">

                        <Checkbox
                          data-testid={`chk-${r.id}`}
                          checked={selected.includes(r.id)}
                          onCheckedChange={() => toggle(r.id)}
                          disabled={status === "All Confirmed"}
                        />

                      </td>


                      <td className="px-4 py-3 font-medium">
                        {monthLabel(r.month)}
                      </td>


                      <td className="px-4 py-3 num text-xs">
                        {r.series}
                      </td>


                      <td className="px-4 py-3 num text-right">
                        {inr(r.gross)}
                      </td>


                      <td className="px-4 py-3 num text-right text-muted-foreground">
                        {inr(r.tds)}
                      </td>


                      <td className="px-4 py-3 num text-right font-medium">
                        {inr(r.net)}
                      </td>


                      <td className="px-4 py-3">

                        <StatusBadge>
                          {status}
                        </StatusBadge>

                      </td>


                      <td className="px-4 py-3">

                        <div className="flex justify-end gap-2">

                          {/* DOWNLOAD */}

                          <Button
                            data-testid={`dl-${r.id}`}
                            size="sm"
                            variant="outline"
                            className="h-8"
                            onClick={() => download(r)}
                          >

                            <Download className="mr-1.5 h-3.5 w-3.5" />

                            Download Excel

                          </Button>


                          {/* UPLOAD PAYMENT */}

                          <Button
                            data-testid={`upload-payment-${r.id}`}
                            size="sm"
                            className="h-8 bg-primary hover:bg-primary/90"
                            onClick={() => openPaymentUpload(r)}
                          >

                            <Upload className="mr-1.5 h-3.5 w-3.5" />

                            Upload Payment

                          </Button>

                        </div>

                      </td>

                    </tr>

                  );

                })}

              </tbody>

            </table>


            {rows.length === 0 && (

              <div className="p-8 text-center text-sm text-muted-foreground">

                No payment records available for this series.

              </div>

            )}

          </div>

        </SectionCard>

      </div>


      {/* ===================================================
          UPLOAD PAYMENT FILE DIALOG
      =================================================== */}

      <Dialog
        open={uploadOpen}
        onOpenChange={setUploadOpen}
      >

        <DialogContent className="sm:max-w-lg">

          <DialogHeader>

            <DialogTitle>
              Upload Bank Payment File
            </DialogTitle>

            <DialogDescription>

              Upload the bank confirmation Excel file for
              payment verification.

            </DialogDescription>

          </DialogHeader>


          {/* SELECTED PERIOD */}

          <div className="rounded-lg border bg-secondary/30 p-4">

            <div className="grid gap-4 sm:grid-cols-3">

              <div>

                <div className="text-xs text-muted-foreground">
                  Period
                </div>

                <div className="mt-1 font-medium">
                  {selectedPaymentRow
                    ? monthLabel(selectedPaymentRow.month)
                    : "-"}
                </div>

              </div>


              <div>

                <div className="text-xs text-muted-foreground">
                  Series
                </div>

                <div className="mt-1 font-medium">
                  {selectedPaymentRow?.series || "-"}
                </div>

              </div>


              <div>

                <div className="text-xs text-muted-foreground">
                  Net Payable
                </div>

                <div className="mt-1 font-medium">
                  {selectedPaymentRow
                    ? inr(selectedPaymentRow.net)
                    : "-"}
                </div>

              </div>

            </div>

          </div>


          {/* UPLOAD AREA */}

          <div
            className="cursor-pointer rounded-xl border-2 border-dashed border-border p-8 text-center transition hover:border-primary/50 hover:bg-secondary/20"
            onClick={() => fileInputRef.current?.click()}
          >

            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx,.xls,.csv"
              className="hidden"
              onChange={handleFileChange}
            />


            {paymentFile ? (

              <>

                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-xl bg-green-50">

                  <FileSpreadsheet className="h-7 w-7 text-green-600" />

                </div>


                <div className="mt-4 font-medium">
                  {paymentFile.name}
                </div>


                <div className="mt-1 text-sm text-muted-foreground">
                  {(paymentFile.size / 1024).toFixed(1)} KB
                </div>


                <div className="mt-3 text-xs text-primary">
                  Click to replace file
                </div>

              </>

            ) : (

              <>

                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-xl bg-primary/10">

                  <Upload className="h-7 w-7 text-primary" />

                </div>


                <div className="mt-4 font-medium">
                  Upload Bank Confirmation File
                </div>


                <div className="mt-1 text-sm text-muted-foreground">
                  Excel or CSV file containing bank payment records
                </div>


                <Button
                  type="button"
                  variant="outline"
                  className="mt-4"
                  onClick={(e) => {
                    e.stopPropagation();
                    fileInputRef.current?.click();
                  }}
                >
                  Browse File
                </Button>

              </>

            )}

          </div>


          {/* MOCK PROCESS NOTE */}

          <div className="rounded-lg border border-blue-200 bg-blue-50 p-4 text-sm text-blue-800">

            <div className="font-medium">
              What happens next?
            </div>

            <div className="mt-1">
              The system will find investor folio numbers,
              compare payment amounts and identify successful
              and failed bank transactions.
            </div>

          </div>


          <DialogFooter>

            <Button
              variant="outline"
              onClick={() => setUploadOpen(false)}
            >
              Cancel
            </Button>


            <Button
              disabled={!paymentFile}
              onClick={startProcessing}
              className="bg-primary hover:bg-primary/90"
            >

              <FileCheck2 className="mr-2 h-4 w-4" />

              Process Bank File

            </Button>

          </DialogFooter>

        </DialogContent>

      </Dialog>


      {/* ===================================================
          EXISTING CONFIRM DIALOG
      =================================================== */}

      <Dialog
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
      >

        <DialogContent>

          <DialogHeader>

            <DialogTitle>
              Confirm {selected.length} month
              {selected.length !== 1 ? "s" : ""}?
            </DialogTitle>

            <DialogDescription>

              Marking a month as{" "}
              <span className="font-medium">
                All Confirmed
              </span>{" "}
              is an operational tracking action. Please review
              the downloaded Excel first.

            </DialogDescription>

          </DialogHeader>


          <div className="rounded-md border border-border p-3 text-sm">

            <div className="flex justify-between">

              <span className="text-muted-foreground">
                Net Payable
              </span>

              <span className="num font-medium">
                {inr(selectedTotal)}
              </span>

            </div>


            <div className="mt-1 flex justify-between">

              <span className="text-muted-foreground">
                TDS obligation
              </span>

              <span className="num font-medium">
                {inr(selectedTds)}
              </span>

            </div>

          </div>


          <DialogFooter>

            <Button
              variant="outline"
              onClick={() => setConfirmOpen(false)}
            >
              Cancel
            </Button>


            <Button
              data-testid="btn-confirm-all"
              onClick={confirmAll}
              className="bg-primary hover:bg-primary/90"
            >
              Confirm as paid
            </Button>

          </DialogFooter>

        </DialogContent>

      </Dialog>

    </div>
  );
}